import styled from 'styled-components'
import { Alert } from 'antd'

const SSAlert = styled(Alert)`
  white-space: normal;

  ${(props) => {
    if (props.type === 'error') {
      return `
        font-family: text--default !important;
        color: #B91C25 !important;
        border: 1px solid #ffa39e !important;
        border-radius: 8px !important;
        background-color: #fff1f0 !important;
      `
    }
  }}

  ${(props) => {
    if (props.small) {
      return `
        &.ant-alert {
          padding: 8px;
        }

        .ant-alert-message {
          font-size: 12px;
          font-family: text--default !important;
        }

        .ant-alert-icon {
          position: relative;
          top: 0px;
          left: 0px;
          margin-right: 5px;
          vertical-align: middle;
        }
      `
    }
  }}
`

export default SSAlert
